// extracted by mini-css-extract-plugin
export default {"details":"CaseDetails_details__yKSxT"};